import React from "react";
import { View, Image, TouchableWithoutFeedback } from "react-native";
import Text from "@components/CustomText";
import RatingView from "./RatingView";
import t from "@constants/localization";
const PATH = "screens/SupportTree/SupportTickets/TicketCard";
const RatingBottomView = ({
  ticket_id,
  givenRating,
  showReopenModalHandler,
  handleReload = () => {},
  ratingDate,
  resolved_at,
  issueLevel1,
}) => {
  const renderRatingImage = (r) => {
    const rating = Number(r);

    switch (rating) {
      case 1:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741486281Terrible_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 30 }}
            />
          </>
        );
      case 2:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741426943Bad_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 30 }}
            />
          </>
        );
      case 3:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741558644Okay_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 30 }}
            />
          </>
        );
      case 4:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741616339Good_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 30 }}
            />
          </>
        );
      case 5:
        return (
          <>
            <Image
              source={{
                uri: "https://pub-storage-svc.citymall.live/1628741680787Great_select.png",
              }}
              style={{ width: 32, height: 32, marginLeft: 30 }}
            />
          </>
        );
    }
  };

  return (
    <View
      style={{
        position: "absolute",
        bottom: 0,
        width: "100%",
        backgroundColor: "white",
        // minHeight: 50,
        elevation: 15,
        zIndex: 5,
        //   padding: 5,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          paddingVertical: 11,
          paddingHorizontal: 20,
          alignItems: "center",
        }}
      >
        <Text variant="subtitle_16" style={{ marginTop: 3, marginRight: 10 }}>
          {givenRating && ratingDate > resolved_at
            ? t(`${PATH}/yourGiven`)
            : ""}
        </Text>
        <View style={{ flex: 1, marginLeft: 0 }}>
          {givenRating && ratingDate > resolved_at ? (
            renderRatingImage(givenRating)
          ) : (
            <View style={{ marginLeft: -35 }}>
              <RatingView
                ticket_id={ticket_id} //clTicketDisSatisfactionReasons={clTicketDisSatisfactionReasons}
                issueLevel1={issueLevel1}
                handleReloadList={handleReload}
                showReopenModalHandler={showReopenModalHandler}
                marginBtw={25}
              />
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default RatingBottomView;
